import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: [],
  },
  getters: {
    list: (state) => state.list,
  },
  actions: {
    create({ commit, dispatch }, model) {
      return ajax.post("Sales/api/BaseSalePrice", model);
    },
    deleteBaseSalePrice({ commit, dispatch }, id) {
      return ajax.delete(
        "Sales/api/********",
        { data: { id: id } },
        { headers: { "Content-Type": "application/json" } }
      );
    },
    listSpecificProductPerBaseSalePrice({ commit, dispatch }, baseSalePriceId) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "Sales/api/SpecificProductDeductionAndIncreasesQuery/Specific-products-Info-of-contract/" +
              baseSalePriceId
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    assignBaseSalePriceItemInfo({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("/api/BaseSalePrice/AssignItems", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
  },
};
